import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

export interface ClassRangeFilters {
  minProgress: number | null;
  minChapters: number | null;
}

@Component({
  selector: 'app-class-range-filters',
  templateUrl: './class-range-filters.component.html',
  styleUrls: ['./class-range-filters.component.scss'],
})
export class ClassRangeFiltersComponent implements OnDestroy {
  @Input() mode: 'classes' | 'users' = 'classes';
  @Input() label = 'Filtros';
  @Output() filtersChange = new EventEmitter<ClassRangeFilters>();

  isOpen = false;
  minProgress: number | null = null;
  minChapters: number | null = null;
  private closeTimer: any;

  get activeCount(): number {
    let count = 0;
    if (this.minProgress !== null && this.minProgress > 0) count++;
    if (this.minChapters !== null && this.minChapters > 0) count++;
    return count;
  }

  /** Stepper display: always 2-digit padded like "08" / "12". */
  get formattedChapters(): string {
    const value = this.minChapters ?? 0;
    return value < 10 ? `0${value}` : value.toString();
  }

  togglePanel(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) clearTimeout(this.closeTimer);
  }

  onMouseEnter(): void {
    clearTimeout(this.closeTimer);
    this.isOpen = true;
  }

  onMouseLeave(): void {
    this.closeTimer = setTimeout(() => {
      this.isOpen = false;
    }, 1000);
  }

  onProgressChange(value: string): void {
    const num = value === '' ? null : Number(value);
    this.minProgress = num !== null && num > 0 ? num : null;
    this.emit();
  }

  incrementChapters(): void {
    const next = (this.minChapters ?? 0) + 1;
    this.minChapters = next;
    this.emit();
  }

  decrementChapters(): void {
    const current = this.minChapters ?? 0;
    const next = Math.max(0, current - 1);
    this.minChapters = next === 0 ? null : next;
    this.emit();
  }

  clearFilters(): void {
    this.minProgress = null;
    this.minChapters = null;
    this.emit();
  }

  private emit(): void {
    this.filtersChange.emit({
      minProgress: this.minProgress,
      minChapters: this.minChapters,
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.closeTimer);
    this.clearFilters();
  }
}
